import {
  faLocationDot,
  faUpload,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect } from "react";
import { shortenFileName } from "src/helpers/helperFunctions";
import { IPrescriptionDetails } from "src/types/GlobalInterfaces";
import PDFDocument from "src/assets/images/website-images/pdf-image.png";
import httpRequest from "src/helpers/httpRequest";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/Store/store";
import { updateIndicators, updateIndicatorsCount } from "src/Store/redDots";
interface IProps {
  onClose: () => void;
  data: IPrescriptionDetails;
  type: "valid" | "nonValid";
  onReadPrescription: (id: string) => void;
}

const ImageViewInPrescription = ({
  imageName,
  label,
  imageClassName,
  imagePath,
}: {
  imageName?: string;
  label?: string;
  imageClassName?: string;
  imagePath?: string;
}) => {
  return (
    <div className="flex flex-col gap-1">
      <p className="font-size-16px font-Poppins-Medium">{label}</p>
      <img
        src={`${
          imagePath?.toLowerCase().endsWith(".pdf") ? PDFDocument : imagePath
        }`}
        alt={imageName}
        className={`w-full max-w-[70px] lg:max-w-[5.5vw] aspect-[1/0.7] object-contain hover:border-[#00A297] transition-all cursor-pointer rounded-lg border border-[#E6E6E6] overflow-hidden block ${imageClassName}`}
        onClick={() => window.open(`${imagePath}`, "_blank")}
      />
      <p className="font-size-15px text-[#303030] font-Poppins-Regular w-[62%]">
        {shortenFileName(imageName || "", 15)}
      </p>
    </div>
  );
};

const AddressDetails = ({
  label,
  value,
  className,
  labelClassName,
}: {
  label: string;
  value: string;
  className?: string;
  labelClassName?: string;
}) => {
  return (
    <div className="flex gap-2">
      <p
        className={`font-size-16px font-Poppins-Medium w-[38%] ${labelClassName}`}
      >
        {label}
      </p>
      <p
        className={`font-size-15px text-[#303030] font-Poppins-Regular w-[62%] ${className}`}
      >
        {value || "-"}
      </p>
    </div>
  );
};

const getNameFromPath = (path: string) => {
  const name = path.split("/").pop();
  return name;
};

const PrescriptionViewModal = ({
  onClose,
  data,
  type,
  onReadPrescription,
}: IProps) => {

  const dispatch = useDispatch();
  const { allIndicators } = useSelector((store: RootState) => store.redDots);

  const readPrescription = async (id: string) => {
    const { res, err } = await httpRequest<any>({
      path: `/customer-prescription/get-read/${id}`,
    });
    if (res) {
      onReadPrescription(id);
      let d = {}
      if(type === "valid") {
        d = { customers_prescribe_valid: allIndicators?.customers_prescribe_valid - 1 };
      } else {
        d = { customers_prescribe_unvalid: allIndicators?.customers_prescribe_unvalid - 1 };
      }
      console.log(d, "d");
      dispatch(updateIndicatorsCount(d));
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (data?.adminNotified === false) {
      readPrescription(data?._id);
    }
  }, [data?.adminNotified]);

  return (
    <div className="fixed top-0 left-0 z-[99] w-full h-full bg-black/70 flex justify-center items-center">
      <div className="bg-[#F6FAFF] flex gap-2 h-fit rounded-lg lg:p-[1.2vw] p-2 w-[80vw] max-w-[1200px] relative">
        <div className="absolute top-[-10px] right-[-10px] bg-red-500 rounded-full w-[20px] h-[20px] flex justify-center items-center">
          <FontAwesomeIcon
            icon={faXmark}
            className="font-size-12px ml-[-1px] text-white cursor-pointer"
            onClick={onClose}
            id="prescription-view-modal-close-btn"
          />
        </div>
        <div className="w-[50%] flex flex-col gap-1.5">
          <div className="flex flex-col gap-1 p-2 bg-white rounded-lg border border-[#E6E6E6]">
            <h2 className="py-2 flex gap-1 font-size-16px font-Poppins-Medium items-center border-b border-[#E6E6E6]">
              <FontAwesomeIcon
                icon={faLocationDot}
                className="font-size-18px"
              />{" "}
              <p>Address Details</p>
            </h2>
            <div className="flex flex-col gap-1.5 lg:gap-[0.5vw] mt-2">
              <AddressDetails
                label="Type"
                value={data?.addressDetails?.addressType}
                className="lowercase first-letter:uppercase"
              />
              <AddressDetails
                label="Emirate"
                value={data?.addressDetails?.emirate}
              />
              <AddressDetails label="City" value={data?.addressDetails?.city} />
              <AddressDetails
                label="Street Address"
                value={data?.addressDetails?.streetAddress}
              />
              <AddressDetails
                label="Flat / Villa No"
                value={data?.addressDetails?.flatNo}
              />
              <AddressDetails
                label="Building Name"
                value={data?.addressDetails?.buildingName}
              />
              <AddressDetails
                label="Additional Information (Area, Landmark)"
                value={data?.addressDetails?.landmarks}
              />
              <AddressDetails
                label="Country"
                value={data?.addressDetails?.country}
              />
            </div>
          </div>
          {/* Personal Details */}
          {type === "valid" && (
            <div className="flex flex-col gap-1 p-2 bg-white rounded-lg border border-[#E6E6E6] h-full">
              <h2 className="py-2 flex gap-1 font-size-16px font-Poppins-Medium items-center border-b border-[#E6E6E6]">
                <FontAwesomeIcon
                  icon={faLocationDot}
                  className="font-size-18px"
                />{" "}
                <p>Personal Details</p>
              </h2>
              <div className="flex flex-col gap-3 mt-2">
                <AddressDetails
                  label="Mobile Number"
                  value={data?.addressDetails?.mobileNumber}
                />
                {/* <AddressDetails label="Phone Number" value={data.addressDetails.phoneNumber} /> */}
                <AddressDetails
                  label="First & Last Name"
                  value={data?.addressDetails?.personName}
                />
              </div>
            </div>
          )}
        </div>
        <div className="w-[50%] flex flex-col gap-1.5 min-h-full">
          {/* Prescription Details */}
          {type === "nonValid" && (
            <div className="flex flex-col gap-1 p-2 bg-white rounded-lg border border-[#E6E6E6]">
              <h2 className="py-2 flex gap-1 font-size-16px font-Poppins-Medium items-center border-b border-[#E6E6E6]">
                <FontAwesomeIcon
                  icon={faLocationDot}
                  className="font-size-18px"
                />{" "}
                <p>Personal Details</p>
              </h2>
              <div className="flex flex-col gap-3 mt-2">
                <AddressDetails
                  label="Mobile Number"
                  value={data?.addressDetails?.mobileNumber}
                />
                {/* <AddressDetails label="Phone Number" value={data.addressDetails.phoneNumber} /> */}
                <AddressDetails
                  label="First & Last Name"
                  value={data?.addressDetails?.personName}
                />
              </div>
            </div>
          )}
          <div className="flex flex-col gap-1 p-2 bg-white rounded-lg border border-[#E6E6E6] h-full">
            <h2 className="py-2 flex gap-1 font-size-16px font-Poppins-Medium items-center border-b border-[#E6E6E6]">
              <FontAwesomeIcon icon={faUpload} className="font-size-18px" />{" "}
              <p>Upload Prescription</p>
            </h2>
            <div className="flex flex-col gap-2 h-full">
              <ImageViewInPrescription
                imageName={getNameFromPath(data?.document || "")}
                imagePath={data?.document}
                label="Prescription"
              />
              {type === "valid" && (
                <>
                  <div className="grid grid-cols-2 gap-2">
                    <ImageViewInPrescription
                      imageName={getNameFromPath(data?.emiratesIdFront || "")}
                      imagePath={data?.emiratesIdFront}
                      label="CNIC (Front)"
                      // label="Emirates ID (Front)"
                    />
                    <ImageViewInPrescription
                      imageName={getNameFromPath(data?.emiratesIdBack || "")}
                      imagePath={data?.emiratesIdBack}
                      label="CNIC (Back)"
                      // label="Emirates ID (Back)"
                    />
                  </div>
                  {/* <div className="grid grid-cols-2 gap-2">
                    <ImageViewInPrescription
                      imageName={getNameFromPath(data?.insuranceIdFront || "")}
                      imagePath={data?.insuranceIdFront}
                      label="Insurance ID (Front)"
                    />
                    <ImageViewInPrescription
                      imageName={getNameFromPath(data?.insuranceIdBack || "")}
                      imagePath={data?.insuranceIdBack}
                      label="Insurance ID (Back)"
                    />
                  </div> */}
                  <div className="">
                    <h2 className="font-size-16px font-Poppins-Medium">
                      Message
                    </h2>
                    <p className="font-size-15px text-[#303030] font-Poppins-Regular">
                      {data?.message}
                    </p>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrescriptionViewModal;
